"use strict";

exports.__esModule = true;
exports.default = datum;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tree = _interopRequireDefault(require("../Datum/Tree"));

var _shallowEqual = _interopRequireDefault(require("../utils/shallowEqual"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function toArray(value) {
  if (!value) return [];
  if (typeof value === 'string') return [value];
  return value;
}

function datum(Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(TreeDatum, _React$Component);

    function TreeDatum(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.datum = new _Tree.default({
        data: props.data,
        loader: props.loader,
        keygen: props.keygen,
        mode: props.mode,
        value: toArray(props.value),
        onChange: props.onChange,
        disabled: typeof props.disabled === 'function' ? props.disabled : undefined
      });
      return _this;
    }

    var _proto = TreeDatum.prototype;

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (prevProps.data !== this.props.data) this.datum.setData(this.props.data);
    };

    _proto.render = function render() {
      var value = this.props.value;

      var props = _objectSpread({}, this.props, {
        datum: this.datum
      });

      if (!(0, _shallowEqual.default)(toArray(value), this.datum.getValue())) {
        this.datum.setValue(toArray(value));
      }

      return _react.default.createElement(Origin, props);
    };

    return TreeDatum;
  }(_react.default.Component), _defineProperty(_class, "propTypes", {
    loader: _propTypes.default.func,
    data: _propTypes.default.array,
    disabled: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
    mode: _propTypes.default.oneOf([0, 1, 2, 3]),
    onChange: _propTypes.default.func,
    value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.string]),
    keygen: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]).isRequired,
    multiple: _propTypes.default.bool
  }), _defineProperty(_class, "defaultProps", {
    mode: 1
  }), _temp;
}